import classnames from 'classnames';

import styles from './styles.module.scss';

function CardBody({ children, className }) {
  return <div className={classnames(styles['card-body'], styles['invisible-scrollbar'], className)}>{children}</div>;
}

export default CardBody;
